"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = exports.SigningStatus = exports.SigningState = void 0;
var SigningState;
(function (SigningState) {
    SigningState["Ok"] = "OK";
    SigningState["Timeout"] = "TIMEOUT";
    SigningState["InvalidCertificate"] = "INVALID_CERTIFICATE";
    SigningState["InvalidSignature"] = "INVALID_SIGNATURE";
    SigningState["UserCancelled"] = "USER_CANCELLED";
    SigningState["EndProviderMisconfiguration"] = "END_PROVIDER_MISCONFIGURATION";
    SigningState["DeviceError"] = "DEVICE_ERROR";
    SigningState["WrongVerificationCode"] = "WRONG_VERIFICATION_CODE";
    SigningState["ProviderError"] = "PROVIDER_ERROR";
    SigningState["SignerCertificateRevoked"] = "SIGNER_CERTIFICATE_REVOKED";
    SigningState["SignerCertificateUnknown"] = "SIGNER_CERTIFICATE_UNKNOWN";
    SigningState["InvalidAuthentication"] = "INVALID_AUTHENTICATION";
    SigningState["FailedUnknown"] = "FAILED_UNKNOWN";
    SigningState["Withdrawn"] = "WITHDRAWN";
    SigningState["OnHold"] = "ON_HOLD";
    SigningState["InternalError"] = "INTERNAL_ERROR";
})(SigningState || (exports.SigningState = SigningState = {}));
var SigningStatus;
(function (SigningStatus) {
    SigningStatus["CompletedOk"] = "COMPLETED_OK";
    SigningStatus["CompletedFailure"] = "COMPLETED_FAILURE";
    SigningStatus["Running"] = "RUNNING";
})(SigningStatus || (exports.SigningStatus = SigningStatus = {}));
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["InactiveCertificate"] = "INACTIVE_CERTIFICATE";
    ErrorCode["NotClient"] = "NOT_CLIENT";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
